import React, { useState, useEffect } from 'react';
import {
  Col, Progress, Row, Spinner,
} from 'reactstrap';

const getPercentage = (value, total) => (
  (Math.round(((value * 100) / total) * 100) / 100) || 0
);

const refreshStats = ({ boxes = [], setOtaStatus, setLoading }) => {
  setLoading(true);
  const succeed = boxes.reduce(
    (total, { versions: { currentVersion, targetVersion } }) => (
      total + ((targetVersion === currentVersion) ? 1 : 0)
    ),
    0,
  );
  const inProgress = boxes.reduce(
    (total, { versions: { currentVersion, targetVersion, lastReceivedVersion } }) => (
      total + ((targetVersion !== currentVersion && targetVersion !== lastReceivedVersion) ? 1 : 0)
    ),
    0,
  );
  const failed = boxes.reduce(
    (total, { versions: { currentVersion, targetVersion, lastReceivedVersion } }) => (
      total + ((targetVersion !== currentVersion && targetVersion === lastReceivedVersion) ? 1 : 0)
    ),
    0,
  );
  setOtaStatus({
    succeed, inProgress, failed, total: boxes.length,
  });
  setTimeout(() => setLoading(false), 1);
};

export const StatsRender = ({
  succeed, inProgress, failed, total, loading, failedButConnected, failedTooManyAttempts,
}) => (
  loading ? <Spinner color="primary" /> : (
    <Col>
      <Row>
        <Progress multi>
          <Progress bar color="success" value={`${getPercentage(succeed, total)}`} />
          <Progress bar color="info" value={`${getPercentage(inProgress, total)}`} />
          <Progress bar color="warning" value={`${getPercentage(failedButConnected, total)}`} />
          <Progress bar color="danger" value={`${getPercentage(failed, total)}`} />
          <Progress bar color="danger" value={`${getPercentage(failedTooManyAttempts, total)}`} />
        </Progress>
      </Row>
      <Row>
        <Col>
          <span className="color-success">
            {`OTA succeed: ${succeed} (${getPercentage(succeed, total)}%)`}
          </span>
        </Col>
        <Col>
          <span className="color-info">
            {`Haven't OTA yet: ${inProgress} (${getPercentage(inProgress, total)}%)`}
          </span>
        </Col>
        <Col>
          <span className="color-warning">
            {`OTA failed (but connected): ${failedButConnected} (${getPercentage(failedButConnected, total)}%)`}
          </span>
        </Col>
        <Col>
          <span className="color-danger">
            {`OTA failed: ${failed} (${getPercentage(failed, total)}%)`}
          </span>
        </Col>
        <Col>
          <span className="color-danger">
            {`OTA failed (aborted, too many attempts): ${failedTooManyAttempts} (${getPercentage(failedTooManyAttempts, total)}%)`}
          </span>
        </Col>
        <Col>
          <span>
            {`Total: ${total}`}
          </span>
        </Col>
      </Row>
    </Col>
  )
);

export default ({ boxes = [] }) => {
  const [loading, setLoading] = useState(false);
  const [otaStatus, setOtaStatus] = useState({
    succeed: 0,
    inProgress: 0,
    failed: 0,
    total: 0,
  });
  useEffect(() => refreshStats({ boxes, setOtaStatus, setLoading }), [boxes]);
  return (
    <StatsRender
      loading={loading}
      succeed={otaStatus.succeed}
      inProgress={otaStatus.inProgress}
      failed={otaStatus.failed}
      total={otaStatus.total}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/ota/Stats.js